import template from '../../templates/help-request-catalog.j2';
import { error, debug } from '../../../core/js/utils/logger';

import { generate } from '../../../core/js/utils/componentUtils';
import { mDom, mDomMaintainInputVals } from '../../../core/js/utils/renderUtils';

import { call } from 'redux-saga/effects';
import { requestCatalogSaga } from '../sagas/sagas';

import { scrollToElement } from '../../../core/js/utils/scrollUtils';

import { getOptionsForUpdateButton } from '../../../core/js/utils/requestUtils';

import {
    genericEmailServiceSuccess,
    genericEmailServiceError
} from '../../../core/js/actions/genericEmailServiceActions';

import { updateButtonTextSaga } from '../../../core/js/sagas/animateButtonSagas';

/**
 * Attach component events to DOM
 * @param {object} store The redux store
 * @returns {undefined}
 */
function attachEvents(store) {
    $(document).on(this.scopedEvent('submit'), this.scopedSelector('.js-generic-email-override'), (e) => {
        debug('#request-catalog-form submit');
        e.preventDefault();
        const formElement = '.js-generic-email-form';
        const formSlug = $(e.target).attr('data-form-slug');
        const templateElement = '.dom-generic-email-service';

        const formData = {
            name: {
                first: $(this.scopedSelector('[name="firstName"]')).val(),
                last: $(this.scopedSelector('[name="lastName"]')).val()
            },
            address1: $(this.scopedSelector('[name="streetAddress1"]')).val(),
            address2: $(this.scopedSelector('[name="streetAddress2"]')).val(),
            city: $(this.scopedSelector('[name="city"]')).val(),
            region: $(this.scopedSelector('[name="state"]')).val(),
            postalCode: $(this.scopedSelector('[name="zip"]')).val(),
            country: $(this.scopedSelector('[name="country"]')).val()
        };

        const updateOptions = getOptionsForUpdateButton(store);

        store.runSaga(updateButtonTextSaga, call(requestCatalogSaga, formData), '.js-generic-email-submit', 2000, updateOptions)
            .done.then(() => {
                store.dispatch(genericEmailServiceSuccess());
                $(formElement).trigger('reset');
                scrollToElement(templateElement);
            }).catch((err) => {
                store.dispatch(genericEmailServiceError(`ERROR_REQUEST_CATALOG_${formSlug.replace(/-/g, '_').toUpperCase()}_SUBMIT_ERROR`));
                scrollToElement(templateElement);
                error(err);
            });

        return false;
    });
}

/**
 * Bootstrap the component onto the page
 * @param {object} store The redux store
 * @param {object} overrides Component-level overrides config
 * @returns {undefined}
 */
export function init(store, overrides = {}) {
    const config = {
        attachEvents: attachEvents,
        template: template,
        name: 'requestCatalog',
        templateLocation: '.dom-request-catalog',
        renderType: mDom,
        renderOptions: mDomMaintainInputVals
    };

    return generate(config, store, overrides);
}
